import React from 'react';
import styled from 'styled-components';
import LinkedInIcon from 'images/footer/LinkedinIcon';
import InstagramIcon from 'images/footer/InstagramIcon';

const SocialMedia = ({ invert, insideMenu, menuIsOpen }) => {
  return (
    <Container invert={invert}>
      <a href="https://www.linkedin.com/company/agencyx-dublin/" target="__blank" id="social-linked-in" aria-label="Agency X LinkedIn Profile" tabIndex={insideMenu && !menuIsOpen ? -1 : 0} aria-hidden={insideMenu && !menuIsOpen}>
        <LinkedInIcon />
      </a>
      <a href="https://www.instagram.com/agency_x_dublin" target="__blank" id="social-instagram" aria-label="Agency X Instagram Profile" tabIndex={insideMenu && !menuIsOpen ? -1 : 0} aria-hidden={insideMenu && !menuIsOpen}>
        <InstagramIcon />
      </a>
    </Container>
  );
};

const Container = styled.div`
  display: flex !important;
  gap: 1.5rem;
  svg {
    width: 2rem;
    circle {
      transition: fill 100ms ease-in-out;
    }

    &:hover {
      circle {
        fill: ${({ invert }) => invert ? '#fff' : 'var(--ax-gold)'};
      }

      path {
        fill: ${({ invert }) => invert ? '#000' : '#fff'};
      }
    }

    &:not(:hover) {
      circle {
        fill: #000;
      }
    }

    &:active {
      circle {
        fill: var(--ax-beige);
      }
    }
  }
`;

export default SocialMedia;
